import { createRoute } from '@/utils/routing'

export const TARGET2_PARTICIPANT_LIST_ROUTE = 'target2-participants'
export const TARGET2_PARTICIPANTS_UPLOAD_ROUTE = 'target2-participants-upload'

export function createTarget2ParticipantListRoute (options = {}) {
  return createRoute(TARGET2_PARTICIPANT_LIST_ROUTE, options)
}

export function createTarget2ParticipantsUploadRoute (options = {}) {
  return createRoute(TARGET2_PARTICIPANTS_UPLOAD_ROUTE, options)
}
